import { render, staticRenderFns } from "./BuyOnRevzillaButton.vue?vue&type=template&id=48390850&scoped=true"
import script from "./BuyOnRevzillaButton.vue?vue&type=script&lang=js"
export * from "./BuyOnRevzillaButton.vue?vue&type=script&lang=js"
import style0 from "./BuyOnRevzillaButton.vue?vue&type=style&index=0&id=48390850&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48390850",
  null
  
)

export default component.exports